document.querySelectorAll('.rich-text-readmore').forEach(function(button) {
  button.addEventListener('click', function(event) {
    event.preventDefault();
    let sectionParent = document.getElementById('shopify-section-' + button.getAttribute('data-id'));
    let clamp = sectionParent.querySelector('.line-clamp-finder');
    let readmore = sectionParent.querySelector('.rich-text-readmore');

    if (readmore.textContent === 'READ MORE') {
      clamp.classList.remove('line-clamp-3');
      readmore.textContent = 'READ LESS';
    } else {
      clamp.classList.add('line-clamp-3');
      readmore.textContent = 'READ MORE';
    }
  });
});






document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(".faq-menu-item");

  // Helper function to toggle dropdown visibility with animation
  function toggleDropdown(dropdown, menuItems) {
    const isOpen = dropdown.classList.contains("open");

    // Close all other open dropdowns
    menuItems.forEach((menuItem) => {
      const otherDropdown = menuItem.querySelector(".faq-dropdown");
      if (otherDropdown && otherDropdown !== dropdown && otherDropdown.classList.contains("open")) {
        closeDropdown(otherDropdown);
      }
    });

    if (isOpen) {
      closeDropdown(dropdown);
    } else {
      openDropdown(dropdown);
    }
  }

  // Open a dropdown
  function openDropdown(dropdown) {
    dropdown.style.display = "block"; // Make it visible
    const height = dropdown.scrollHeight; // Get its full height
    dropdown.style.height = "0"; // Start collapsed
    requestAnimationFrame(() => {
      dropdown.style.height = `${height}px`; // Expand to full height
    });
    dropdown.classList.add("open"); // Add the 'open' class
    dropdown.previousElementSibling.classList.add("opened"); // Add the 'opened' class

    dropdown.addEventListener(
      "transitionend",
      function handleTransitionEnd() {
        dropdown.style.height = ""; // Clean up height inline style
        dropdown.removeEventListener("transitionend", handleTransitionEnd);
      }
    );
  }

  // Close a dropdown
  function closeDropdown(dropdown) {
    dropdown.style.height = `${dropdown.scrollHeight}px`; // Set height to current height
    requestAnimationFrame(() => {
      dropdown.style.height = "0"; // Collapse to zero height
    });
    
    dropdown.previousElementSibling.classList.remove("opened"); // Remove the 'opened' class

    dropdown.addEventListener(
      "transitionend",
      function handleTransitionEnd() {
        dropdown.style.display = "none"; // Fully hide after animation
        dropdown.classList.remove("open"); // Remove the 'open' class
        dropdown.style.height = ""; // Clean up inline styles
        dropdown.removeEventListener("transitionend", handleTransitionEnd);
      }
    );
  }

  // Attach click events to menu items
  menuItems.forEach((menuItem) => {
    const dropdown = menuItem.querySelector(".faq-dropdown");

    if (dropdown) {
      menuItem.addEventListener("click", function (e) {
        e.stopPropagation(); // Prevent the event from bubbling
        e.preventDefault(); // Prevent default behavior (if necessary)

        toggleDropdown(dropdown, menuItems);
      });
    }
  });

  // Close dropdowns when clicking outside
  document.addEventListener("click", function () {
    menuItems.forEach((menuItem) => {
      const dropdown = menuItem.querySelector(".faq-dropdown");
      if (dropdown && dropdown.classList.contains("open")) {
        closeDropdown(dropdown);
      }
    });
  });
});




// target the titles in the football and rugby teams pages
document.querySelectorAll('.rich-text__heading').forEach(h => {
  const text = h.textContent.trim();

  // Match: "Officially Licensed {Something} Branded Mats"
  const match = text.match(/^Officially Licensed (.+ Branded Mats)$/);

  if (match) {
    h.innerHTML = `
      <span class="title_team_prefix">Officially Licensed</span>
      <span class="title_team_emphasis">${match[1]}</span>
    `;
  }
});